/**
 * Browser API Stub for Production Build
 * 
 * Stub for @merlin/lib/js/browser-api when building as standalone library.
 * Real implementation should be provided by the consuming application.
 */

// Stub browser API - does nothing but prevents errors
export const browserAPI = {
    runtime: {
        sendMessage: () => Promise.resolve(),
        onMessage: {
            addListener: () => {},
            removeListener: () => {},
        },
    },
    storage: {
        local: {
            get: () => Promise.resolve({}),
            set: () => Promise.resolve(),
            remove: () => Promise.resolve(),
        },
    },
    tabs: {
        query: () => Promise.resolve([]),
        sendMessage: () => Promise.resolve(),
    },
};

// Stub storage helper - uses localStorage as fallback
export const storage = {
    get: async (keys) => {
        if (typeof localStorage === 'undefined') return {};
        const result = {};
        const keyList = Array.isArray(keys) ? keys : [keys];
        keyList.forEach(key => {
            const value = localStorage.getItem(`a2ui_${key}`);
            if (value !== null) {
                try {
                    result[key] = JSON.parse(value);
                } catch {
                    result[key] = value;
                }
            }
        });
        return result;
    },
    set: async (items) => {
        if (typeof localStorage === 'undefined') return;
        Object.entries(items).forEach(([key, value]) => {
            localStorage.setItem(`a2ui_${key}`, JSON.stringify(value));
        });
    },
    remove: async (keys) => {
        if (typeof localStorage === 'undefined') return;
        const keyList = Array.isArray(keys) ? keys : [keys];
        keyList.forEach(key => {
            localStorage.removeItem(`a2ui_${key}`);
        });
    },
};

export default { browserAPI, storage };
